<!-- 时刻表 -->
<template>
  <div class="skb">
    <div class="title">浙江大学班车时刻表</div>
    <div class="body">
      <div class="item" v-for="(item, index) in list" :key="index + 'list'">
        <div class="sub_title">{{ item.title }}</div>
        <div
          class="my_img"
          v-for="(zitem, zindex) in item.imglist"
          :key="zindex + 'img'"
        >
          <img
            class="img"
            :src="require(`../assets/image/skb/${zitem}.png`)"
            alt=""
            width="100%"
            height="100%"
          />
        </div>
        <div class="tip" v-if="item.tip">{{ item.tip }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeTable',
  data() {
    return {
      list: [
        {
          title: '教师 1 号班车周一至周五运行',
          imglist: ['1-1', '1-2'],
          tip: ''
        },
        {
          title: '教师 2 号班车周一至周五运行',
          imglist: ['2-1', '2-2'],
          tip: ''
        },
        {
          title: '教师 3 号班车周一至周五运行',
          imglist: ['3-1', '3-2'],
          tip: ''
        },
        {
          title: '教师 4 号班车周一至周五运行',
          imglist: ['4-1', '4-2'],
          tip:
            '注：湖滨与紫金港校区之间往来，请配合搭乘教师 3 号和教师校区间 1 号，紫金港、玉泉、西溪、湖滨往来班车。'
        },
        { title: '教师 5 号班车周一至周五运行', imglist: ['5-1'], tip: '' },
        {
          title: '教师 6 号班车周一至周五运行',
          imglist: ['6-1', '6-2'],
          tip: ''
        },
        {
          title: '教师 7 号班车周一至周五运行',
          imglist: ['7-1'],
          tip:
            '注：1.序号 2—4 趟次为上辅修、必选课专用，无课时不运行；2.序号 3 趟次，湖滨只下不上！序号 3 行走线路 ：在上课时有多辆班车运行，其中只有一辆班车沿途教职工可要求驾驶员在交通规则允许的情况下，停靠下车。该班车设有“沿途允许停靠”指示牌，行走线路为：古墩路—文一路—丰潭路—天目山路—浙大路—曙光路—杭大路—天目山路—凯旋路；沿途教职工可要求驾驶员在交通规则允许的情况下，由司机确定停靠点停靠下车。3.本班车的安排，随上课需求而变化较多，请乘车前务请查询总务处网页最新班车时刻表！'
        },
        {
          title: '教师 8 号班车周六至周日运行',
          imglist: ['8-1'],
          tip:
            '注：1.本班车的上课趟次，时刻表中未列入，务请乘车前查询校综合服务网“班车查询”或“浙大生活”微信公众号。2.上课临时增加车辆只在有课时运行！3.非上课学生搭乘，务请听从司机安排。'
        },
        {
          title: '教师 9 号班车周一至周五运行',
          imglist: ['9-1', '9-2'],
          tip: ''
        },
        {
          title: '教师 9 号班车（紫金港校内循环）周一至周五运行',
          imglist: ['10-1', '10-2'],
          tip: ''
        },
        {
          title: '教师 10 号班车周一至周日运行',
          imglist: ['11-1'],
          tip:
            '注：1.此班车教职工优先；有空位时允许住在华家池校区的研究生在“医学院、农生环组团”停靠点上车乘坐，其他学生不得乘坐；超载时请搭乘其他交通工具； 2.西溪校区、湖滨只下不上； 3.行走线路为 古墩路—文一路—丰潭路—天目山路—玉古路—浙大路—曙光路—杭大路—天目山路—凯旋路；教职工沿途可要求驾驶员在交通规则允许的情况下，由司机确定停靠点停靠下车。'
        },
        { title: '教师 11 号班车周一至周五运行', imglist: ['12-1'], tip: '' },
        {
          title: '教师 12 号班车周一至周五运行',
          imglist: ['13-1', '13-2'],
          tip: ''
        },
        {
          title: '教师 13 号班车周一至周五运行',
          imglist: ['14-1', '14-2'],
          tip: ''
        },
        {
          title: '教师 14 号班车周一至周五运行',
          // imglist: ['15-1', '15-2'],
          imglist: ['15-1'],
          tip: ''
        },
        { title: '教师 15 号班车周一至周五运行', imglist: ['16-1'], tip: '' },
        {
          title: '教师 16 号班车周一至周五运行',
          imglist: ['17-1', '17-2'],
          tip: ''
        },
        {
          title: '教师校区间 1 号班车周一至周五运行',
          imglist: ['18-1'],
          tip: ''
        },
        {
          title: '教师校区间 2 号班车周一至周五运行',
          imglist: ['19-1'],
          tip: ''
        },
        {
          title: '教师校区间 3 号班车周一至周五运行',
          imglist: ['20-1', '20-2'],
          tip: ''
        },
        {
          title: '研究生 1 号班车周一至周五运行',
          imglist: ['21-1'],
          tip: '注：此班车仅在研究生上课期间运行'
        },
        {
          title: '研究生 2 号班车周一至周五运行',
          imglist: ['22-1'],
          tip:
            '注：此班车仅在研究生上课期间运行。只停靠每趟次下所注的停靠点，其他停靠点一律不停靠'
        },
        {
          title: '学生教学专用 1 号班车周一至周五运行',
          imglist: ['23-1'],
          tip: '注：凭学生证乘坐！'
        },
        { title: '紫金港教学区短驳班车', imglist: ['24-1'], tip: '' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.skb {
  height: 100%;
  .title {
    padding-top: 10px;
    line-height: 40px;
    text-align: center;
    font-size: 20px;
    font-weight: 550;
  }
  .sub_title {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    font-weight: 550;
  }
  .body {
    margin: 7px;
    width: calc(100% - 14px);
    min-height: 100px;
  }
  .my_img {
    width: 100%;
    .img {
      display: block;
    }
  }
  .tip {
    line-height: 20px;
    font-size: 12px;
  }
}
</style>
